/* eslint-disable */
// reducers
import {
    TOGGLE_LOADING,
    FETCH_ASSET_SELECT_TYPE_LIST,
    SET_BREADCRUMB_STATUS,
    SET_SELECTED_ASSET_TYPE,
    SET_BASE_UPLOAD_DATA,
    SET_GLOBAL_FIELDS_DATA,
    SAVE_GLOBAL_FIELDS_DATA,
    SET_SELECTED_ASSET_PUBLISH,
    DIRECT_PUBLISH_ASSET,
    EDIT_ASSET,
    PUBLISH_ASSET,
    FETCH_CONTENT_TYPE_LIST,
    UNAUTHORIZED_ASSET_UPLOAD,
    SET_SELECTED_CATEGORIES,
    SET_SELECTED_CAMPAIGNS,
    SET_SELECTED_HASHTAGS,
    SET_SELECTED_CONTENT_TYPE,
  } from "../../constants/AssetLibActionTypes";
  
  const initialState = {
    loading: false,
    breadcrumbStatus: 0,
    selectTypeList: [],
    campaignList: [],
    landingpageUrlList: [],
    showcaseUrlList: [],
    landingSecureUrl: null,
    showcaseSecureUrl: null,
    micrositeUrl: null,
    customUrl: null,
    greetingId: null,
    selectedAssetType: {},
    baseUploadData: {},
    globalFieldsData: {},
    globalCategories: [],
    globalSubCategories: [],
    globalCampaigns: [],
    globalHashtags: [],
    selectedCategories: [],
    selectedSubCategories: [],
    selectedCampaigns: [],
    selectedHashtags: [],
    selectedGreetings: null,
    selectedContentType: null,
    selectedDefineUrl: null,
    saveGlobalFieldsData: [],
    partnersList: [],
    usersList: [],
    directPublish: false,
    editAsset: false,
    selectedAssetPublish: {},
    publishAsset: {},
    contentTypeList: [],
    keywordsList: [],
    ctaList: [],
    unauthorizedAssetUpload: null,
  };
  
  const assetUploadReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case TOGGLE_LOADING:
        return { ...state, loading: payload };
      case FETCH_ASSET_SELECT_TYPE_LIST:
        return { ...state, selectTypeList: payload };
      case SET_BREADCRUMB_STATUS:
        return { ...state, breadcrumbStatus: payload };
      case SET_SELECTED_ASSET_TYPE:
        return { ...state, selectedAssetType: payload };
      case SET_BASE_UPLOAD_DATA:
        return { ...state, baseUploadData: payload };
      case SET_GLOBAL_FIELDS_DATA:
        return {
          ...state,
          globalFieldsData: payload.globalFields,
          globalCategories: payload.selectedCategory,
          globalHashtags: payload.selectedHashtag,
        };
      case SET_SELECTED_CATEGORIES:
        return { ...state, selectedCategories: payload };
      case SET_SELECTED_CAMPAIGNS:
        return { ...state, selectedCampaigns: payload };
      case SET_SELECTED_HASHTAGS:
        return { ...state, selectedHashtags: payload };
      case SET_SELECTED_CONTENT_TYPE:
        return { ...state, selectedContentType: payload };
       case SAVE_GLOBAL_FIELDS_DATA:
        return { ...state, saveGlobalFieldsData: payload };
      case SET_SELECTED_ASSET_PUBLISH:
        return { ...state, selectedAssetPublish: payload };
      case DIRECT_PUBLISH_ASSET:
        return { ...state, directPublish: payload };
      case EDIT_ASSET:
        return { ...state, editAsset: payload };
      case PUBLISH_ASSET:
        return { ...state, publishAsset: payload };
      case FETCH_CONTENT_TYPE_LIST:
        return { ...state, contentTypeList: payload };
      case UNAUTHORIZED_ASSET_UPLOAD:
        return { ...state, unauthorizedAssetUpload: payload };
      default:
        return state;
    }
  };
  export default assetUploadReducer;  